// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2dP_1","approved":"Status_approved__3Kh5c","rejected":"Status_rejected__3Y_xT","expired":"Status_expired__2i0ju","label":"Status_label__1vOJP"};